// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { ArrowLeft, Plus, Trash2, Search, LogOut } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'sonner';

// // const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// // Change line 9
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
// const API = `${BACKEND_URL}/api`;

// const AdminPage = () => {
//   const navigate = useNavigate();
//   const [featuredShops, setFeaturedShops] = useState([]);
//   const [allShops, setAllShops] = useState([]);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [location] = useState({ lat: -7.0393, lon: 112.7618 });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);

//   // Check authentication on mount
//   useEffect(() => {
//     const token = localStorage.getItem('admin_token');
//     if (!token) {
//       toast.error('Silakan login terlebih dahulu');
//       navigate('/admin/login');
//     }
//   }, [navigate]);

//   // Fetch featured shops
//   const fetchFeaturedShops = async () => {
//     try {
//       const response = await axios.get(`${API}/featured-shops`);
//       setFeaturedShops(response.data);
//     } catch (error) {
//       console.error('Error fetching featured shops:', error);
//     }
//   };

//   // Fetch all available shops with pagination
//   const fetchAllShops = async (page = 1, append = false) => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${API}/shops/${page}/${location.lon}/${location.lat}`
//       );
//       if (response.data && response.data.data) {
//         const newShops = response.data.data;
//         if (append) {
//           setAllShops(prev => [...prev, ...newShops]);
//         } else {
//           setAllShops(newShops);
//         }
//         setHasMore(newShops.length > 0);
//       }
//     } catch (error) {
//       console.error('Error fetching shops:', error);
//       toast.error('Gagal memuat data warung');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchFeaturedShops();
//     fetchAllShops(1);
//   }, []);

//   // Load more shops
//   const loadMoreShops = () => {
//     const nextPage = currentPage + 1;
//     setCurrentPage(nextPage);
//     fetchAllShops(nextPage, true);
//   };

//   // Add shop to featured
//   const addFeaturedShop = async (shop) => {
//     try {
//       const token = localStorage.getItem('admin_token');
//       const payload = {
//         alias: shop.alias,
//         store_name: shop.store_name,
//         address: shop.address
//       };
//       await axios.post(`${API}/featured-shops`, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`
//         }
//       });
//       toast.success(`${shop.store_name} ditambahkan ke UMKM Pilihan`);
//       fetchFeaturedShops();
//     } catch (error) {
//       console.error('Error adding featured shop:', error);
//       if (error.response?.status === 400) {
//         toast.error('Warung sudah ada di UMKM Pilihan');
//       } else if (error.response?.status === 401) {
//         toast.error('Sesi login expired, silakan login kembali');
//         localStorage.removeItem('admin_token');
//         navigate('/admin/login');
//       } else {
//         toast.error('Gagal menambahkan warung');
//       }
//     }
//   };

//   // Remove shop from featured
//   const removeFeaturedShop = async (alias) => {
//     try {
//       const token = localStorage.getItem('admin_token');
//       await axios.delete(`${API}/featured-shops/${alias}`, {
//         headers: {
//           Authorization: `Bearer ${token}`
//         }
//       });
//       toast.success('Warung dihapus dari UMKM Pilihan');
//       fetchFeaturedShops();
//     } catch (error) {
//       console.error('Error removing featured shop:', error);
//       if (error.response?.status === 401) {
//         toast.error('Sesi login expired, silakan login kembali');
//         localStorage.removeItem('admin_token');
//         navigate('/admin/login');
//       } else {
//         toast.error('Gagal menghapus warung');
//       }
//     }
//   };

//   // Logout handler
//   const handleLogout = () => {
//     localStorage.removeItem('admin_token');
//     toast.success('Logout berhasil');
//     navigate('/admin/login');
//   };

//   // Filter shops not in featured list
//   const availableShops = allShops.filter(
//     shop => !featuredShops.some(featured => featured.alias === shop.alias)
//   );

//   const filteredAvailableShops = searchQuery
//     ? availableShops.filter(shop =>
//         shop.store_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         shop.address.toLowerCase().includes(searchQuery.toLowerCase())
//       )
//     : availableShops;

//   return (
//     <div className="min-h-screen bg-background">
//       {/* Header */}
//       <header className="bg-surface border-b border-border sticky top-0 z-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center gap-4">
//               <button
//                 onClick={() => navigate('/')}
//                 className="p-2 hover:bg-muted rounded-lg transition-colors"
//               >
//                 <ArrowLeft className="w-5 h-5" />
//               </button>
//               <div>
//                 <h1 className="text-2xl font-bold text-foreground">Admin Panel</h1>
//                 <p className="text-sm text-muted-foreground">Kelola UMKM Pilihan</p>
//               </div>
//             </div>
//             <button
//               onClick={handleLogout}
//               className="flex items-center gap-2 px-4 py-2 text-error hover:bg-error/10 rounded-lg transition-colors"
//             >
//               <LogOut className="w-4 h-4" />
//               <span className="hidden sm:inline">Logout</span>
//             </button>
//           </div>
//         </div>
//       </header>

//       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
//         {/* Featured Shops Section */}
//         <section className="bg-surface rounded-xl border border-border p-6">
//           <div className="flex items-center justify-between mb-6">
//             <h2 className="text-xl font-bold text-foreground">UMKM Pilihan</h2>
//             <span className="text-sm text-muted-foreground">
//               {featuredShops.length} warung dipilih
//             </span>
//           </div>

//           {featuredShops.length === 0 ? (
//             <div className="text-center py-12 border-2 border-dashed border-border rounded-lg">
//               <div className="text-4xl mb-3">📌</div>
//               <p className="text-muted-foreground">Belum ada UMKM yang dipilih</p>
//               <p className="text-sm text-muted-foreground mt-1">
//                 Tambahkan warung dari daftar di bawah
//               </p>
//             </div>
//           ) : (
//             <div className="space-y-3">
//               {featuredShops.map((shop) => (
//                 <div
//                   key={shop.alias}
//                   className="flex items-center justify-between p-4 bg-primary-light border border-primary/20 rounded-lg hover:border-primary/40 transition-colors"
//                 >
//                   <div className="flex-1">
//                     <h3 className="font-semibold text-foreground">{shop.store_name}</h3>
//                     <p className="text-sm text-muted-foreground">{shop.address}</p>
//                   </div>
//                   <button
//                     onClick={() => removeFeaturedShop(shop.alias)}
//                     className="p-2 text-error hover:bg-error/10 rounded-lg transition-colors"
//                   >
//                     <Trash2 className="w-5 h-5" />
//                   </button>
//                 </div>
//               ))}
//             </div>
//           )}
//         </section>

//         {/* Available Shops Section */}
//         <section className="bg-surface rounded-xl border border-border p-6">
//           <div className="mb-6">
//             <h2 className="text-xl font-bold text-foreground mb-4">Tambah Warung</h2>
//             <div className="relative">
//               <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
//               <input
//                 type="text"
//                 placeholder="Cari nama warung atau alamat..."
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 className="w-full pl-10 pr-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors"
//               />
//             </div>
//           </div>

//           {loading && currentPage === 1 ? (
//             <div className="text-center py-12">
//               <div className="w-8 h-8 border-4 border-primary/30 border-t-primary rounded-full animate-spin mx-auto"></div>
//               <p className="text-muted-foreground mt-3">Memuat data warung...</p>
//             </div>
//           ) : filteredAvailableShops.length === 0 ? (
//             <div className="text-center py-12">
//               <div className="text-4xl mb-3">🔍</div>
//               <p className="text-muted-foreground">Tidak ada warung ditemukan</p>
//             </div>
//           ) : (
//             <>
//               <div className="space-y-3 max-h-96 overflow-y-auto">
//                 {filteredAvailableShops.map((shop) => (
//                   <div
//                     key={shop.alias}
//                     className="flex items-center justify-between p-4 border border-border rounded-lg hover:border-primary/40 hover:bg-muted/30 transition-colors"
//                   >
//                     <div className="flex-1">
//                       <h3 className="font-semibold text-foreground">{shop.store_name}</h3>
//                       <p className="text-sm text-muted-foreground line-clamp-1">{shop.address}</p>
//                       <div className="flex items-center gap-3 mt-2 text-xs text-muted-foreground">
//                         <span>📍 {shop.distance}</span>
//                         <span>📦 {shop.total_product} produk</span>
//                         <span className={shop.is_open === 'open' ? 'text-success' : 'text-muted-foreground'}>
//                           {shop.is_open === 'open' ? '🟢 Buka' : '🔴 Tutup'}
//                         </span>
//                       </div>
//                     </div>
//                     <button
//                       onClick={() => addFeaturedShop(shop)}
//                       className="ml-4 p-2 bg-primary text-primary-foreground hover:bg-primary-hover rounded-lg transition-colors"
//                     >
//                       <Plus className="w-5 h-5" />
//                     </button>
//                   </div>
//                 ))}
//               </div>
              
//               {/* Load More Button */}
//               {hasMore && !searchQuery && (
//                 <div className="flex justify-center mt-6">
//                   <button
//                     onClick={loadMoreShops}
//                     disabled={loading}
//                     className="px-8 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                   >
//                     {loading ? 'Memuat...' : 'Muat Lebih Banyak'}
//                   </button>
//                 </div>
//               )}
//             </>
//           )}
//         </section>
//       </main>
//     </div>
//   );
// };

// export default AdminPage;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ArrowLeft, Plus, Trash2, Search, LogOut, Image } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

const AdminPage = () => {
  const navigate = useNavigate();
  const [featuredShops, setFeaturedShops] = useState([]);
  const [allShops, setAllShops] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [location] = useState({ lat: -7.0393, lon: 112.7618 });
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // Check authentication on mount
  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      toast.error('Silakan login terlebih dahulu');
      navigate('/admin/login');
    }
  }, [navigate]);

  // Fetch featured shops
  const fetchFeaturedShops = async () => {
    try {
      const response = await axios.get(`${API}/featured-shops`);
      setFeaturedShops(response.data);
    } catch (error) {
      console.error('Error fetching featured shops:', error);
    }
  };

  // Fetch all available shops with pagination
  const fetchAllShops = async (page = 1, append = false) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API}/shops/${page}/${location.lon}/${location.lat}`
      );
      if (response.data && response.data.data) {
        const newShops = response.data.data;
        if (append) {
          setAllShops(prev => [...prev, ...newShops]);
        } else {
          setAllShops(newShops);
        }
        setHasMore(newShops.length > 0);
      }
    } catch (error) {
      console.error('Error fetching shops:', error);
      toast.error('Gagal memuat data warung');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeaturedShops();
    fetchAllShops(1);
  }, []);

  // Load more shops
  const loadMoreShops = () => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    fetchAllShops(nextPage, true);
  };

  // Add shop to featured
  const addFeaturedShop = async (shop) => {
    try {
      const token = localStorage.getItem('admin_token');
      const payload = {
        alias: shop.alias,
        store_name: shop.store_name,
        address: shop.address
      };
      await axios.post(`${API}/featured-shops`, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      toast.success(`${shop.store_name} ditambahkan ke UMKM Pilihan`);
      fetchFeaturedShops();
    } catch (error) {
      console.error('Error adding featured shop:', error);
      if (error.response?.status === 400) {
        toast.error('Warung sudah ada di UMKM Pilihan');
      } else if (error.response?.status === 401) {
        toast.error('Sesi login expired, silakan login kembali');
        localStorage.removeItem('admin_token');
        navigate('/admin/login');
      } else {
        toast.error('Gagal menambahkan warung');
      }
    }
  };

  // Remove shop from featured
  const removeFeaturedShop = async (alias) => {
    try {
      const token = localStorage.getItem('admin_token');
      await axios.delete(`${API}/featured-shops/${alias}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      toast.success('Warung dihapus dari UMKM Pilihan');
      fetchFeaturedShops();
    } catch (error) {
      console.error('Error removing featured shop:', error);
      if (error.response?.status === 401) {
        toast.error('Sesi login expired, silakan login kembali');
        localStorage.removeItem('admin_token');
        navigate('/admin/login');
      } else {
        toast.error('Gagal menghapus warung');
      }
    }
  };

  // Logout handler
  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    toast.success('Logout berhasil');
    navigate('/admin/login');
  };

  // Filter shops not in featured list
  const availableShops = allShops.filter(
    shop => !featuredShops.some(featured => featured.alias === shop.alias)
  );

  const filteredAvailableShops = searchQuery
    ? availableShops.filter(shop =>
        shop.store_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        shop.address.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : availableShops;

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-surface border-b border-border sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate('/')}
                className="p-2 hover:bg-muted rounded-lg transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <div>
                <h1 className="text-2xl font-bold text-foreground">Admin Panel</h1>
                <p className="text-sm text-muted-foreground">Kelola UMKM Pilihan</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate('/admin/banners')}
                className="flex items-center gap-2 px-4 py-2 border border-border hover:bg-muted rounded-lg transition-colors"
                title="Kelola Banner"
              >
                <Image className="w-4 h-4" />
                <span className="hidden sm:inline">Banner</span>
              </button>
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 px-4 py-2 text-error hover:bg-error/10 rounded-lg transition-colors"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Logout</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
        {/* Featured Shops Section */}
        <section className="bg-surface rounded-xl border border-border p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold text-foreground">UMKM Pilihan</h2>
            <span className="text-sm text-muted-foreground">
              {featuredShops.length} warung dipilih
            </span>
          </div>

          {featuredShops.length === 0 ? (
            <div className="text-center py-12 border-2 border-dashed border-border rounded-lg">
              <div className="text-4xl mb-3">📌</div>
              <p className="text-muted-foreground">Belum ada UMKM yang dipilih</p>
              <p className="text-sm text-muted-foreground mt-1">
                Tambahkan warung dari daftar di bawah
              </p>
            </div>
          ) : (
            <div className="space-y-3">
              {featuredShops.map((shop) => (
                <div
                  key={shop.alias}
                  className="flex items-center justify-between p-4 bg-primary-light border border-primary/20 rounded-lg hover:border-primary/40 transition-colors"
                >
                  <div className="flex-1">
                    <h3 className="font-semibold text-foreground">{shop.store_name}</h3>
                    <p className="text-sm text-muted-foreground">{shop.address}</p>
                  </div>
                  <button
                    onClick={() => removeFeaturedShop(shop.alias)}
                    className="p-2 text-error hover:bg-error/10 rounded-lg transition-colors"
                  >
                    <Trash2 className="w-5 h-5" />
                  </button>
                </div>
              ))}
            </div>
          )}
        </section>

        {/* Available Shops Section */}
        <section className="bg-surface rounded-xl border border-border p-6">
          <div className="mb-6">
            <h2 className="text-xl font-bold text-foreground mb-4">Tambah Warung</h2>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
              <input
                type="text"
                placeholder="Cari nama warung atau alamat..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors"
              />
            </div>
          </div>

          {loading && currentPage === 1 ? (
            <div className="text-center py-12">
              <div className="w-8 h-8 border-4 border-primary/30 border-t-primary rounded-full animate-spin mx-auto"></div>
              <p className="text-muted-foreground mt-3">Memuat data warung...</p>
            </div>
          ) : filteredAvailableShops.length === 0 ? (
            <div className="text-center py-12">
              <div className="text-4xl mb-3">🔍</div>
              <p className="text-muted-foreground">Tidak ada warung ditemukan</p>
            </div>
          ) : (
            <>
              <div className="space-y-3 max-h-96 overflow-y-auto">
                {filteredAvailableShops.map((shop) => (
                  <div
                    key={shop.alias}
                    className="flex items-center justify-between p-4 border border-border rounded-lg hover:border-primary/40 hover:bg-muted/30 transition-colors"
                  >
                    <div className="flex-1">
                      <h3 className="font-semibold text-foreground">{shop.store_name}</h3>
                      <p className="text-sm text-muted-foreground line-clamp-1">{shop.address}</p>
                      <div className="flex items-center gap-3 mt-2 text-xs text-muted-foreground">
                        <span>📍 {shop.distance}</span>
                        <span>📦 {shop.total_product} produk</span>
                        <span className={shop.is_open === 'open' ? 'text-success' : 'text-muted-foreground'}>
                          {shop.is_open === 'open' ? '🟢 Buka' : '🔴 Tutup'}
                        </span>
                      </div>
                    </div>
                    <button
                      onClick={() => addFeaturedShop(shop)}
                      className="ml-4 p-2 bg-primary text-primary-foreground hover:bg-primary-hover rounded-lg transition-colors"
                    >
                      <Plus className="w-5 h-5" />
                    </button>
                  </div>
                ))}
              </div>
              
              {/* Load More Button */}
              {hasMore && !searchQuery && (
                <div className="flex justify-center mt-6">
                  <button
                    onClick={loadMoreShops}
                    disabled={loading}
                    className="px-8 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {loading ? 'Memuat...' : 'Muat Lebih Banyak'}
                  </button>
                </div>
              )}
            </>
          )}
        </section>
      </main>
    </div>
  );
};

export default AdminPage;
